module.exports = __webpack_public_path__ + "img/trash.c9896a89.svg";